/**
 * The registry contexts
 *
 * This list contains all the different parts of our code which we want to auto-load.
 * At the moment, these are mostly vue-related parts, but this may change in the future.
 * The registry contexts are an async collection of require.context webpack calls,
 * which can be split into separate bundles for convenience. Have a look at the style guide example below.
 *
 * @type {Array}
 */
const contexts = [
    Promise.resolve({
        type: 'component',
        namespace: 'cmp',
        context: require.context('../../framework/components', true, /index\.(?:js|vue)$/),
    }),
    Promise.resolve({
        type: 'component',
        namespace: 'page',
        context: require.context('../../framework/pages', true, /index\.(?:js|vue)$/),
    }),
    Promise.resolve({
        type: 'filter',
        context: require.context('../../framework/filters', true, /index\.js$/),
    }),
    Promise.resolve({
        type: 'directive',
        context: require.context('../../framework/directives', true, /index\.js$/),
    }),
    Promise.resolve({
        type: 'store',
        context: require.context('../../framework/vuex/modules', true, /index\.js$/),
    }),
];

// Test if we're on the style guide
if (window.styleguide) {
    contexts.push(new Promise((resolve) => {
        require.ensure([], () => {
            resolve({
                type: 'component',
                namespace: 'sty',
                context: require.context('../../framework/styleguide', true, /index\.(js|vue)$/),
            });
        });
    }));
}

export default Promise.all(contexts);



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/base/registry-contexts.js